import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { loanStatusInfo } from '../../cmg-1003/models';

function createInitialState(): loanStatusInfo {
  return <loanStatusInfo>{};
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'cmg-1003-loan-status-history-store' })
export class Cmg1003LoanStatusHistoryStore extends Store<loanStatusInfo> {
  constructor() {
    super(createInitialState());
  }

  akitaPreUpdate = (model: Readonly<loanStatusInfo>, updatedModel: loanStatusInfo) => {
    return updatedModel;
  };
}
